import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=27549e68&"
var script = {}
import style0 from "./Testimonial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports